import NodeInjector from "../services/Dom/NodeInjector";

export const toBranchLabel = (branchNameOrKey: string) => {
  return branchNameOrKey
    .replace(/__meta_v2__$/, "")
    .replace("master__latest", "master");
}

export const resolveAsJson = async (url: string) => {
  const response = await fetch(url);
  return await response.json();
};

export const resolveInjection = (url: string) => NodeInjector.script(url);

export const getBundlePath = (path: string) => path.substring(0, path.lastIndexOf('/'));

export const waitFor = function (
  condition: () => boolean,
  onReady: () => void | Promise<void>,
  delay = 300,
  timeout = 30_000,
): Promise<void> {
  return new Promise((resolve, reject) => {
    const startedAt = Date.now();

    const checkCondition = () => {
      try {
        if (condition()) {
          Promise.resolve(onReady()).then(resolve, reject);
          return;
        }
      } catch (error) {
        reject(error);
        return;
      }

      const elapsed = Date.now() - startedAt;
      if (elapsed >= timeout) {
        reject(new Error(`Timed out waiting for a dependent bundle after ${timeout}ms.`));
        return;
      }

      setTimeout(checkCondition, Math.min(delay, timeout - elapsed));
    };

    checkCondition();
  });
};
